var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import CONSTANTS from 'services/CONSTANTS';
var HeaderMenu = (function (_super) {
    __extends(HeaderMenu, _super);
    function HeaderMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HeaderMenu.prototype, "headerMenu", {
        get: function () {
            return {
                inner: [
                    { to: '/', text: this.$t('header_menu.home_page') },
                    { to: '/join', text: this.$t('header_menu.become_a_driver') },
                    { to: '/', text: this.$t('header_menu.send_a_package') }
                ],
                holder: [
                    { to: '/about', text: this.$t('header_menu.about_page') },
                    { to: '/faq', text: this.$t('header_menu.faq_page') },
                    { to: '/contacts', text: this.$t('header_menu.contacts_page') },
                    { to: '/terms', text: 'Ehdot' },
                    { to: '/privacy', text: 'Rekisteriseloste' }
                ]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMenu.prototype, "accountLink", {
        get: function () {
            return CONSTANTS.REDIRECT_MAP[this.$auth.$state.user && this.$auth.$state.user.role]
                || CONSTANTS.REDIRECT_MAP.default;
        },
        enumerable: true,
        configurable: true
    });
    HeaderMenu.prototype.hideMenu = function () {
        this.$emit('hideMenu');
    };
    HeaderMenu = __decorate([
        Component
    ], HeaderMenu);
    return HeaderMenu;
}(Vue));
export default HeaderMenu;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/layuots/HeaderMenu.vue
// module id = ./node_modules/ts-loader/index.js!./node_modules/tslint-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/layuots/HeaderMenu.vue
// module chunks = 15